// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"13a6f4c2","513":"b9420501","703":"52eb3f67","787":"51a65c7d"}[chunkId] + ".chunk.js";
};